import React, { useState } from 'react';
import {
  Grid,
  Typography,
  Accordion,
  AccordionDetails,
  List,
  AccordionSummary,
} from '@mui/material';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material/styles';

const AccordionSummaryWrapper = styled(AccordionSummary)(
  ({ theme }) => `
      &.Mui-expanded {
        min-height: 48px;
      }
  
      .MuiAccordionSummary-content.Mui-expanded {
        margin: 12px 0;
      }
  
      .MuiSvgIcon-root {
        transition: ${theme.transitions.create(['color'])};
      }
  
      &.MuiButtonBase-root {
  
        margin-bottom: ${theme.spacing(0.5)};
  
        &:last-child {
          margin-bottom: 0;
        }
  
        &.Mui-expanded,
        &:hover {
          background: ${theme.colors.alpha.black[10]};
  
          .MuiSvgIcon-root {
            color: ${theme.colors.primary.main};
          }
        }
      }
  `
);

function AccordionEvaluationCompetenceItem(props) {
  const [expanded, setExpanded] = useState<string | false>('section1');
  const [openByDefault, setOpen] = useState(props.open || false);
  const tmp = () => { }
  const onChange: Function = props.onChange || tmp;

  const handleChangeSection = (section: string) => (
    _event: React.SyntheticEvent,
    isExpanded: boolean
  ) => {
    setExpanded(isExpanded ? section : false);
    setOpen(isExpanded ? true : false);
    onChange();
  };
  return (
    <Grid item xs={12} >
      <Accordion style={{ marginBottom: 0 }}
        expanded={expanded === 'section2' || openByDefault}
        onChange={handleChangeSection('section2')}
      >
        <AccordionSummaryWrapper style={{ backgroundColor: '#2c9a42', color: '#ffffff', borderRadius: 4, marginLeft: 5, marginRight: 5 }} expandIcon={<ExpandCircleDownIcon style={{ color: '#ffffff' }} />}>
          <Grid item xs={12}>
            <Typography variant="h5" style={{ color: '#ffffff' }}>
              {props.title}
            </Typography>
          </Grid>
        </AccordionSummaryWrapper>
        <AccordionDetails sx={{ p: 0 }} >
          <List component="nav" style={{ paddingTop: 0 }}>
            {props.accordionContent}
          </List>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
}

export default AccordionEvaluationCompetenceItem;